<template>
  <div class="modal-login">
    <div class="loginbox">
      <div class="colselogin" @click="closeModal()">×</div>
      <div class="modal-content-login">
        <h2>Sign Up</h2>
        <p>Sign up with Google or Apple</p>

        <div class="googlebuttonbox">
          <!-- <div class="gicon">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-google"></use>
            </svg>
          </div> -->
          <div id="g_id_onload"
            data-client_id="386542798820-ebrc5182hidokcqt50k6iga2qlji6p0c.apps.googleusercontent.com"
            data-callback="handleCredentialResponse" data-auto_prompt="false" data-auto_select="true"></div>
          <div class="g_id_signin" data-type="standard" data-size="large" data-theme="outline" data-text="continue_with"
            data-shape="pill" data-width="350" data-logo_alignment="center"></div>

          <!-- Apple登录按钮 -->
          <div class="apple-auth-button">
            <div id="appleid-signin" data-mode="center-align" data-type="sign in" data-color="black" data-border="true"
              data-border-radius="15" data-width="350" data-height="40" data-label="Sign in with Apple">
            </div>
          </div>
        </div>

        <div class="divider"><span>OR</span></div>

        <div class="createuser" v-if="iscreate">
          <div class="input-group">
            <input type="text" placeholder="First name" v-model="firstName" />
            <input type="text" placeholder="Last name" v-model="lastName" />
          </div>

          <input type="email" placeholder="Email" v-model="email" />
          <input type="password" placeholder="Password" v-model="password" />

          <button class="create-account" @click="createtempaccount">
            Create an account
          </button>
          <p>
            Already have an account?
            <a href="#" @click="iscreate = false">Sign in</a>
          </p>
        </div>
        <div class="sinnbox" v-if="!iscreate">
          <input type="email" placeholder="Email" v-model="email" />
          <input type="password" placeholder="Password" v-model="password" />

          <button v-loading="isclick_login" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)" class="create-account" @click="userlogin">Login</button>
          <p>
            Don't have an account?
            <a href="#" @click="iscreate = true">Sign up</a>
          </p>
        </div>
      </div>
      <p class="terms">
        By creating or entering an account, you agree to the
        <a @click="goindex('temsservice')" href="#">Terms of Service</a> and
        <a @click="goindex('PrivacyPolicy')" href="#">Privacy Policy</a>.
      </p>
      <img :src="banner1" class="banner" alt="banner" />
    </div>

  </div>
</template>

<script>
export default {
  name: "LoginPage",
  props: {},
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      banner1: require("@/assets/images/index/banner7.png"),
      isVisible: false,
      isclick_login: false,

      iscreate: true,
      isRegistering: false,
      appleClientId: '', // Apple 登录的 clientId
    };
  },
  mounted() {
    window.handleCredentialResponse = this.handleCredentialResponse; // 关键：将方法注册为全局函数
    
    // 添加浏览器检测和调试信息
    this.detectBrowserAndLog();
    
    // 重新加载google登录插件
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    document.head.appendChild(script);

    // 打印当前环境信息，方便调试
    console.log('Current environment:', this.getEnvironment());

    // 初始化 Apple 登录
    this.initializeAppleLogin();
  },
  methods: {
    goindex(pagekey) {
      this.$router.push({ name: "IndexPage", params: { pagekey: pagekey } });
    },
    async createaccount() {
      // 测试请求方式为post的relogin接口
      const ret = await this.$axios.post("/api/relogin/", {
        email: "email",
        password: "mima",
      });
      console.log(ret.data);
    },
    async handleCredentialResponse(response) {
      console.log('=== Google登录响应处理开始 ===');
      console.log('响应对象:', response);
      
      if (response.credential) {
        console.log('✅ 收到Google credential');
        console.log('Token长度:', response.credential.length);
        console.log('Token前50字符:', response.credential.substring(0, 50) + '...');
        
        try {
          // 验证JWT token格式
          const tokenParts = response.credential.split(".");
          console.log('Token分段数量:', tokenParts.length);
          console.log('Header长度:', tokenParts[0]?.length || 0);
          console.log('Payload长度:', tokenParts[1]?.length || 0);
          console.log('Signature长度:', tokenParts[2]?.length || 0);
          
          if (tokenParts.length !== 3) {
            console.error("❌ JWT token格式无效 - 分段数量:", tokenParts.length);
            this.$message.error("登录验证失败，请重试");
            return;
          }

          // 获取payload部分并验证是否为有效的base64字符串
          const payloadBase64 = tokenParts[1];
          console.log('Payload Base64原始:', payloadBase64.substring(0, 50) + '...');
          
          if (!payloadBase64) {
            console.error("❌ JWT token payload为空");
            this.$message.error("登录验证失败，请重试");
            return;
          }

          // 解码 JWT token 以获取用户信息
          let payload;
          try {
            console.log('🔄 开始解码JWT token...');
            // 处理base64字符串，确保正确的padding
            const base64 = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
            const paddedBase64 = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
            console.log('处理后的Base64长度:', paddedBase64.length);
            console.log('Padding差异:', paddedBase64.length - payloadBase64.length);
            
            payload = JSON.parse(atob(paddedBase64));
            console.log('✅ JWT解码成功');
            console.log('用户ID (sub):', payload.sub);
            console.log('邮箱:', payload.email);
            console.log('用户名:', payload.name);
            console.log('发行者 (iss):', payload.iss);
            console.log('过期时间 (exp):', new Date(payload.exp * 1000));
          } catch (decodeError) {
            console.error("❌ JWT token解码失败:", decodeError);
            console.error("解码错误详情:", decodeError.message);
            console.error("原始payload:", payloadBase64);
            this.$message.error("登录验证失败，请重试");
            return;
          }

          // 验证必要的用户信息
          if (!payload.sub || !payload.email) {
            console.error("❌ 用户信息不完整 - sub:", !!payload.sub, "email:", !!payload.email);
            this.$message.error("登录信息不完整，请重试");
            return;
          }

          console.log('✅ 用户信息验证通过，准备发送到服务器');
          // 在这里，您可以将用户信息发送到您的后端服务器进行验证和进一步处理
          this.sendToServer(payload);
        } catch (error) {
          console.error("❌ Google登录处理异常:", error);
          console.error("错误堆栈:", error.stack);
          this.$message.error("Google登录失败，请重试");
        }
      } else {
        console.error("❌ 未收到Google credential");
        // 处理登录失败的情况
        this.$message.error("Login failed");
      }
    },
    async sendToServer(payload) {
      console.log('=== 发送用户数据到服务器 ===');
      try {
        const subid = payload.sub;
        const email = payload.email;
        const username = payload.name;
        
        console.log('准备发送的数据:');
        console.log('- subid:', subid);
        console.log('- email:', email);
        console.log('- username:', username);
        
        if (!subid || !email) {
          console.error("❌ 缺少必需的用户数据 - subid:", !!subid, "email:", !!email);
          this.$message.error("用户信息不完整，请重试");
          return;
        }

        console.log('🔄 向服务器发送登录请求...');
        const startTime = Date.now();
        
        // 根据subid获取用户信息,没有注册则自动根据subid注册
        const userdata = await this.$axios.post(
          "/api/getuserdata/",
          {
            subid: subid,
            email: email,
            username: username,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        
        const requestTime = Date.now() - startTime;
        console.log(`✅ 服务器响应时间: ${requestTime}ms`);
        console.log('服务器响应:', userdata.data);
        
        const resdaata = userdata.data;
        if (resdaata.code == 200) {
          console.log('✅ 登录成功，设置用户cookie');
          // cookie保存登录信息
          this.$cookies.set("subid", resdaata.subid, { expires: 30 });
          this.$cookies.set("username", resdaata.username, { expires: 30 });
          this.$cookies.set("email", resdaata.email, { expires: 30 });
          this.$cookies.set("userlogin", true, { expires: 30 });
          
          console.log('🚀 跳转到首页');
          this.$router.push("/home");
        } else {
          console.error("❌ 服务器返回错误:", resdaata);
          console.error("错误代码:", resdaata.code);
          console.error("错误信息:", resdaata.messages || resdaata.message);
          this.$message.error("登录失败，请重试");
        }
      } catch (error) {
        console.error("❌ 发送用户数据失败:", error);
        console.error("错误类型:", error.name);
        console.error("错误信息:", error.message);
        
        if (error.response) {
          // 服务器返回了错误响应
          console.error("服务器错误状态:", error.response.status);
          console.error("服务器错误数据:", error.response.data);
          this.$message.error(`服务器错误: ${error.response.status}`);
        } else if (error.request) {
          // 网络请求失败
          console.error("网络请求失败:", error.request);
          this.$message.error("网络连接失败，请检查网络后重试");
        } else {
          // 其他错误
          console.error("其他错误:", error.message);
          this.$message.error("登录过程中发生错误，请重试");
        }
      }
    },
    validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        return false;
      } else {
        return true;
      }
    },
    async createtempaccount() {
      if (this.isRegistering) return;
      this.isRegistering = true;

      try {
        // 随机生一个邮箱和subid
        let guestId = localStorage.getItem("guestId");
        if (!guestId) {
          guestId = this.getOrCreateGuestId();
        }
        const subid =
          Math.random().toString(36).substring(2, 15) +
          Math.random().toString(36).substring(2, 15);
        // const email =
        //   Math.random().toString(36).substring(2, 15) + "@easynoteai.com";
        const email = this.email;
        const password = this.password;
        const username = this.firstName + " " + this.lastName;
        if (!email) {
          this.$message.error("please input your email");
          return;
        }
        if (!this.validateEmail(email)) {
          this.$message.error("please input a valid email");
          return;
        }
        if (!password) {
          this.$message.error("please input your password");
          return;
        }
        if (!username) {
          this.$message.error("please input your name");
          return;
        }
        if (subid) {
          // console.log(response.subid);
          // 根据subid获取用户信息,没有注册则自动根据subid注册
          const userdata = await this.$axios.post(
            "/api/getuserdata/",
            {
              subid: subid,
              email: email,
              username: username,
              password: password,
              guestid: guestId,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          const resdaata = userdata.data;
          if (resdaata.code == 202) {
            this.$message.error("email already exists");
            this.iscreate = false;
            return;
          }
          if (resdaata.code == 200) {
            // cookie保存登录信息
            this.$cookies.set("subid", resdaata.subid, { expires: 30 });
            this.$cookies.set("username", resdaata.username, { expires: 30 });
            this.$cookies.set("email", resdaata.email, { expires: 30 });
            this.$cookies.set("userlogin", true, { expires: 30 });
            this.$router.push("/home");
          }
          // 注册成功后跳转到首页
        }
      } finally {
        this.isRegistering = false;
      }
    },
    async userlogin() {

      const email = this.email;
      const password = this.password;
      if (!email) {
        this.$message.error("please input your email");
        return;
      }
      if (!password) {
        this.$message.error("please input your password");
        return;
      }

      this.isclick_login = true;
      const userdata = await this.$axios.post(
        "/api/emaillogin/",
        {
          email: email,
          password: password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        
      );
      const resdaata = userdata.data;
      this.isclick_login = false;
      if (resdaata.code == 200) {
        // cookie保存登录信息
        this.$cookies.set("subid", resdaata.subid, { expires: 30 });
        this.$cookies.set("username", resdaata.username, { expires: 30 });
        this.$cookies.set("email", resdaata.email, { expires: 30 });
        this.$cookies.set("userlogin", true, { expires: 30 });
        this.$router.push("/home");
      } else {
        this.$message.error("login failed");
      }
    },
    openModal() {
      this.isVisible = true;
    },
    closeModal() {
      this.isVisible = false;
    },
    generateUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    getOrCreateGuestId() {
      let guestId = localStorage.getItem("guestId");
      if (!guestId) {
        guestId = this.generateUUID();
        localStorage.setItem("guestId", guestId);
        console.log("新的游客ID已创建:", guestId);
      } else {
        console.log("已有游客ID:", guestId);
      }
      return guestId;
      // 你可以在这里将游客ID发送到你的服务器进行记录
      // 例如：this.sendGuestIdToServer(guestId);
    },
    initializeAppleLogin() {
      // 根据域名判断使用哪个 clientId
      const hostname = window.location.hostname;
      if (hostname.includes('online')) {
        this.appleClientId = 'online.easynoteai.applelogin';
      } else if (hostname.includes('com')) {
        this.appleClientId = 'com.easynoteai.applelogin';
      } else {
        // 本地开发环境
        this.appleClientId = 'online.easynoteai.applelogin';
      }

      const appleScript = document.createElement("script");
      appleScript.type = "text/javascript";
      appleScript.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";

      appleScript.onload = () => {
        if (window.AppleID) {
          window.AppleID.auth.init({
            clientId: this.appleClientId,
            scope: 'name email',
            redirectURI: window.location.protocol + '//' + window.location.host + '/api/applecallback/',
            state: 'origin:web',
            usePopup: true
          });

          // 添加事件监听器
          document.addEventListener('AppleIDSignInOnSuccess', this.handleAppleSignIn);
          document.addEventListener('AppleIDSignInOnFailure', this.handleAppleSignInError);
        }
      };

      document.head.appendChild(appleScript);
    },
    async handleAppleSignIn(event) {
      console.log('Apple Sign In Response:', event);
      if (event.detail && event.detail.authorization) {
        const { authorization } = event.detail;

        try {
          // 发送到后端验证
          const response = await this.$axios.post('/api/applecallback/', {
            code: authorization.code,
            id_token: authorization.id_token
          });

          if (response.data.code === 200) {
            // 设置用户信息
            this.$cookies.set("subid", response.data.subid, { expires: 30 });
            this.$cookies.set("username", response.data.username, { expires: 30 });
            this.$cookies.set("email", response.data.email, { expires: 30 });
            this.$cookies.set("userlogin", true, { expires: 30 });

            // 提示成功
            this.$message.success('Login successful');

            // 跳转到首页
            this.$router.push("/home");
          } else {
            throw new Error(response.data.messages || 'Login failed');
          }
        } catch (error) {
          console.error('Apple login error:', error);
          this.$message.error(error.message || 'Login failed. Please try again.');
        }
      }
    },
    handleAppleSignInError(error) {
      console.error('Apple Sign In Error:', error);
      // this.$message.error('Apple sign in failed');
    },
    getEnvironment() {
      const hostname = window.location.hostname;
      if (hostname.includes('online')) {
        return 'online';
      } else if (hostname.includes('com')) {
        return 'com';
      }
      return 'development';
    },
    detectBrowserAndLog() {
      const browserInfo = this.getBrowserInfo();
      console.log('=== 登录页面浏览器检测 ===');
      console.log('浏览器信息:', browserInfo);
      console.log('User Agent:', navigator.userAgent);
      console.log('语言设置:', navigator.language);
      console.log('Cookie启用:', navigator.cookieEnabled);
      console.log('时区:', Intl.DateTimeFormat().resolvedOptions().timeZone);
      
      // 检查潜在的登录问题
      if (!browserInfo.isChrome && !browserInfo.isEdge) {
        console.warn('⚠️ 非Chrome/Edge浏览器，可能存在兼容性问题');
      }
      
      if (!navigator.cookieEnabled) {
        console.error('❌ Cookie未启用，登录可能失败');
      }
    },
    getBrowserInfo() {
      const userAgent = navigator.userAgent;
      const isChrome = /Chrome/.test(userAgent) && !/Edge|Edg/.test(userAgent);
      const isSafari = /Safari/.test(userAgent) && !/Chrome|Chromium/.test(userAgent);
      const isFirefox = /Firefox/.test(userAgent);
      const isEdge = /Edge|Edg/.test(userAgent);
      
      // 获取浏览器版本
      let version = 'unknown';
      if (isChrome) {
        const match = userAgent.match(/Chrome\/(\d+)/);
        version = match ? match[1] : 'unknown';
      } else if (isSafari) {
        const match = userAgent.match(/Version\/(\d+)/);
        version = match ? match[1] : 'unknown';
      } else if (isFirefox) {
        const match = userAgent.match(/Firefox\/(\d+)/);
        version = match ? match[1] : 'unknown';
      } else if (isEdge) {
        const match = userAgent.match(/Edg\/(\d+)/);
        version = match ? match[1] : 'unknown';
      }

      return {
        isChrome,
        isSafari,
        isFirefox,
        isEdge,
        version,
        userAgent,
        browserName: isChrome ? 'Chrome' : isSafari ? 'Safari' : isFirefox ? 'Firefox' : isEdge ? 'Edge' : 'Unknown',
        supportsJWT: true, // 大多数现代浏览器都支持
        supportsCOOP: isChrome || isEdge || isFirefox, // Safari的COOP支持可能有问题
      };
    },
  },
};
</script>

<style lang="less">
.modal-login {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;

  .banner {

    position: absolute;
    top: 4vw;
    width: 100vw;
    padding: 0;
    left: 0;
    z-index: 0;
    opacity: 0.7;
  }

  .loginbox {

    background-color: rgb(14 16 20);

    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;


    .colselogin {
      position: absolute;
      right: 25px;
      top: 20px;
      font-size: 30px;
      cursor: pointer;
    }

    .modal-content-login {
      position: relative;
      z-index: 10;
      background-color: rgba(255, 255, 255, 0.1);
      box-shadow: 0px 0px 2px #eee;
      border-radius: 15px;
      padding: 5px 20px;
      color: white;
      width: 350px !important;
    }
  }


  h2 {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 30px;
  }

  p {
    color: #b5bac1;
    margin-bottom: 20px;
  }

  #g_id_onload {
    display: flex !important;
    justify-content: center !important;
  }

  .googlebuttonbox {
    width: 350px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .divider {
    text-align: center;
    margin: 28px 0;
    height: 0px;
    color: #b5bac1;
    border: 1px solid #65798d;
    position: relative;

    span {
      position: absolute;
      top: -10px;
      padding: 0px 10px;
      left: 50%;
      translate: -50%;
      background-color: #2d2d37;
    }
  }

  .input-group {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
  }

  input {
    width: calc(100% - 24px);
    padding: 12px;
    border: 1px solid #65798d;
    background-color: rgb(16 21 26);
    border-radius: 8px;
    color: white;
    margin-bottom: 10px;
  }

  .create-account {
    width: 100%;
    padding: 15px 10px;
    background-color: #8845fc;

    border: none;
    border-radius: 10px;
    color: white;
    cursor: pointer;
    margin-bottom: 20px;
    margin-top: 20px;

    .el-loading-spinner {
      margin-top: -10px !important;
    }
  }

  a {
    color: #9232ff;
    text-decoration: none;
  }

  .terms {
    font-size: 12px;
    text-align: center;
  }

  .apple-auth-button {
    margin-top: 15px;
    width: 350px;
    height: 45px;
    display: flex;
    justify-content: center;
    cursor: pointer;
  }

  #appleid-signin {
    width: 350px !important;
    height: 40px !important;
    border-radius: 20px !important;
    overflow: hidden;
    margin: 0 auto;
  }

  // 确保 Apple 按钮样式正确显示
  .apple-auth-button iframe {
    width: 100% !important;
    height: 100% !important;
    border-radius: 20px !important;
  }
}
</style>
